export interface Link {
  id: string
  label: string
  url: string
}

export interface PersonalInfo {
  fullName?: string
  title?: string
  email?: string
  phone?: string
  location?: string
  birthDate?: string
  links?: Link[]
  photo?: string // Base64 data URL
}

export interface Experience {
  id: string
  company?: string
  position?: string
  location?: string
  startDate?: string
  endDate?: string
  current?: boolean
  description?: string
  highlights?: string[]
}

export interface Education {
  id: string
  institution?: string
  degree?: string
  field?: string
  location?: string
  startDate?: string
  endDate?: string
  current?: boolean
  gpa?: string
  highlights?: string[]
}

export interface Skills {
  technical?: string[]
  soft?: string[]
  tools?: string[]
}

export interface Language {
  id: string
  name?: string
  level?: 'native' | 'fluent' | 'advanced' | 'intermediate' | 'basic'
}

export interface Certification {
  id: string
  name?: string
  issuer?: string
  date?: string
  url?: string
}

export interface Project {
  id: string
  name?: string
  description?: string
  url?: string
  technologies?: string[]
}

export type DateFormat = 'month-year' | 'year-only'
export type CVLanguage = 'es' | 'en' | 'fr' | 'pt' | 'de'

export interface CVSettings {
  dateFormat?: DateFormat
  colorPalette?: string // Palette ID (e.g., 'blue', 'coral', 'indigo')
  language?: CVLanguage // Language for CV labels (default: 'en')
  showContactIcons?: boolean // Show icons next to email, phone, location (default: false)
  customLabels?: Partial<import('../utils/cvTranslations').CVLabels> // User-overridden section labels
}

export interface CV {
  personalInfo?: PersonalInfo
  summary?: string
  experience?: Experience[]
  education?: Education[]
  skills?: Skills
  languages?: Language[]
  certifications?: Certification[]
  projects?: Project[]
  settings?: CVSettings
}

export interface CVState {
  cv: CV
  isDirty: boolean
  lastSaved: Date | null
}

export type LanguageLevel = Language['level']

export const LANGUAGE_LEVELS: { value: LanguageLevel; label: string }[] = [
  { value: 'native', label: 'Nativo' },
  { value: 'fluent', label: 'Fluido' },
  { value: 'advanced', label: 'Avanzado' },
  { value: 'intermediate', label: 'Intermedio' },
  { value: 'basic', label: 'Basico' },
]
